<template>
  <!-- ------------------ 出行订单 ------------------ -->
  <div :label="table_list_itle"
       name="fourth">
    <el-table v-loading="listLoading"
              :data="bookingListData"
              class="all-booking"
              width="100%"
              :header-cell-style="{ background: '#F5F7FA', color: '#606266' }">
      <el-table-column label=" 活动信息">
        <template slot-scope="activeinfo">
          <div style="font-size: 15px; font-weight: bold">
            {{ activeinfo.row.title }}
          </div>
          <div style="font-size: 13px">
            <i v-show="activeinfo.row.ex_product == '已匹配套餐'"
               style="color: green"
               class="el-icon-circle-check"
               :title="activeinfo.row.ex_product"></i>
            <i v-show="activeinfo.row.ex_product != '已匹配套餐'"
               style="color: red"
               class="el-icon-circle-close"
               :title="activeinfo.row.ex_product"></i>
            套餐：{{ activeinfo.row.package }}
          </div>
          <div style="font-size: 13px">
            参加日期：{{ activeinfo.row.trip_start_date }}
          </div>
          <div style="font-size: 13px">
            时间/场次：{{ activeinfo.row.trip_start_time }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label=" 预定人信息"
                       width="160%">
        <template slot-scope="contactinfo">
          <div class="resveration_contactor_infromation">
            <div style="margin-bottom: 10px">
              <div>联系人： {{ contactinfo.row.contact_name }}</div>
              <div>电话： {{ contactinfo.row.contact_phone }}</div>
            </div>

            <span class="num_join_traveller"
                  v-show="contactinfo.row.adult_num"
                  style="font-size: 12px">成人：{{ contactinfo.row.adult_num }}</span>
            <span class="num_join_traveller"
                  v-show="contactinfo.row.child_num"
                  style="font-size: 12px">儿童：{{ contactinfo.row.child_num }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="订单信息"
                       width="250%">
        <template slot-scope="bookinginfo">
          <div style="font-size: 13px">
            订单来源：
            <span style="font-size: 13px; color: #ff5421">{{
              bookinginfo.row.booking_source
            }}</span>
          </div>
          <div style="font-size: 13px">
            系统单号： {{ bookinginfo.row.booking_no }}
          </div>
          <div style="font-size: 13px">
            平台单号： {{ bookinginfo.row.ota_id }}
          </div>
          <div style="font-size: 13px">
            下单日期：{{ bookinginfo.row.created_date }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="订单状态"
                       width="100%"
                       align="center">
        <template slot-scope="statusinfo">
          <button-drop-down :tagData="statusinfo.row.status"
                            :bookingID="statusinfo.row.booking_no"
                            :otaId="statusinfo.row.ota_id"></button-drop-down>
        </template>
      </el-table-column>

      <el-table-column label=" 操作"
                       align="center"
                       width="180">
        <template slot-scope="bookinginfo">
          <el-button-group>
            <!-- 获取订单详情的 按钮,drawer=true, -->
            <el-button @click="openDrawer(bookinginfo.row.booking_no)"
                       size="mini"
                       :plain="true"
                       disabled
                       type="primary">详细</el-button>
            <!-- 确认单 -->
            <el-button @click="getVoucher(bookinginfo.row.booking_no)"
                       size="mini"
                       type="primary"
                       :plain="true"
                       icon="el-icon-document-checked"></el-button>

            <!-- 出行人 -->
            <el-button @click="selectBookingTraveller(bookinginfo.row.booking_no)"
                       size="mini"
                       type="primary"
                       :plain="true"
                       icon="el-icon-s-custom"></el-button>
          </el-button-group>

          <el-button-group style="margin-top: 5px">
            <!-- ---------处理订单---------- -->
            <el-button size="mini"
                       @click="dealWithBooking(bookinginfo.row)"
                       type="primary"
                       icon="el-icon-message">处理</el-button>
            <!-- ---------修改订单信息---------- -->
            <el-button size="mini"
                       @click="reviseBooking(bookinginfo.row)"
                       type="primary"
                       icon="el-icon-document-copy">修改</el-button>
          </el-button-group>
          <!-- 备注 -->
          <popover-textarea :booking_detial="bookinginfo.row"></popover-textarea>
          <!-- <div class="remark_line_div">
            <div
              style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >备注：{{bookinginfo.row.booking_remark}}</div>
          </div>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- ----------------- 分页 ------------------ -->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange_system"
                     :small="true"
                     background
                     layout="prev, pager, next,total"
                     :current-page.sync="pagenum_system"
                     :page-size="pagesize"
                     :total="page_account"></el-pagination>
    </div>
  </div>
</template>

<script>
import ButtonDropDown from '../common/modify/ButtonDropDown'
import PopoverTextarea from '../common/modify/PopoverTextarea'
export default {
  name: 'booking-list-template',
  components: {
    'popover-textarea': PopoverTextarea,
    'button-drop-down': ButtonDropDown,
  },
  data() {
    return {
      showModifyStatus: false, // 显示修改订单
      bookinginfo: '',
      loading: this.listLoading,
      pagenum_system: 1, // 当前页
      pagesize: this.pagesize_system, // 每页容量，自行设定
      dialogReviseBooking: false, // 修改订单的对话框是否可见
    }
  },
  watch: {},
  props: {
    table_list_itle: '',
    bookingListData: Array,
    listLoading: Boolean,
    page_account: Number, // 总条数
    pagesize_system: Number,
  },
  methods: {
    // 修改 订单状态
    mouseOverModifyStatus(event) {
      this.showModifyStatus = true
    },
    mouseLeaveModifyStatus(event) {
      this.showModifyStatus = false
    },
    // 打开添加出行人对话框
    selectBookingTraveller(bookinginfo_booking_no) {
      this.$emit('selectBookingTraveller', bookinginfo_booking_no)
    },

    dealWithBooking(value) {
      this.$emit('dealWithBooking', value)
    },
    reviseBooking(item) {
      // this.bookinginfo = item;
      this.$emit('editBooking', item)
    },
    getVoucher(bookinginfo_booking_no) {
      this.$emit('getVoucher', bookinginfo_booking_no)
    },

    // 处理当前页的变动
    handleCurrentChange_system(val) {
      // console.log(`每页 ${val} 条`);
      this.$emit('handlePageChange_system', val)
    },
  },
}
</script>

<style>
.num_join_traveller {
  width: 40%;
  margin-right: 5px;
  padding: 5px 10px;
  background-color: rgb(236, 236, 236);
  border-radius: 5px;
}

.resveration_contactor_infromation {
  padding: 10px 0px;
  font-size: 12px;
}
.remark_line_div {
  /* margin-top: 10px; */
  margin: 8px;
  /* border-top: 1px solid #ff5421; */
  border: 1px solid #ff5421;
  border-radius: 3px;
  font-size: 12px;
  padding-left: 10px;
  text-align: left;
  /* //溢出用省略号显示 */
}
.remark_line_button {
  margin: 8px;
  width: 90%;
  /* border-top: 1px solid #ff5421; */
  font-size: 12px;
  padding-left: 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #ff5421;
}
</style>